export const routeMappings = {
  // English to Arabic mappings
  '/en/': '/',
  '/en/cart': '/ar/cart',

  // Arabic to English mappings
  '/ar/cart': '/en/cart',
  '/': '/en/',
};
